import TestimonialsImg from 'assets/images/testimonials.png';
import useTranslation from 'hooks/useTranslation';

const Testimonials = () => {
  const translation = useTranslation();

  return (
    <div className="bg-background-light-blue px-4 py-20 lg:px-[147px] lg:py-[120px] xl:px-[20%]">
      <div className='relative flex flex-col lg:flex-row lg:justify-between'>
        <img
          alt=""
          src={TestimonialsImg}
          className="absolute right-4 top-[75px] h-[88px] w-[88px] lg:left-[47%] lg:-top-[10%]"
        />

        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-primary-light-blue">
            {translation.testimonials}
          </p>
          <p className="mt-3 text-2xl font-bold text-primary-blue lg:text-4xl">
            {translation.whatOurClientSay}
          </p>
        </div>

        <div className="relative mt-[60px] pr-10 lg:mt-0 lg:max-w-[563px]">
          <span className="bg-clip-text text-xl font-medium text-primary-blue lg:text-[28px] lg:leading-relaxed">
            {translation.weLoveHowWebsnap}
          </span>

          <div className="flex flex-col lg:mt-6 lg:flex-row lg:items-center">
            <p className="mt-8 text-base font-bold text-primary-blue lg:mt-0 lg:text-lg">
              Audrey Racheter
            </p>
            <p className="mx-1 hidden text-xl font-bold text-primary-grey lg:block">
              -
            </p>
            <p className="mt-2 text-sm text-primary-grey lg:mt-0 lg:text-base">
              {translation.headOfOperation}
            </p>
          </div>

          <div className="mt-10 flex items-center lg:mt-[60px]">
            <div className="h-1 w-6 rounded-full bg-primary-light-blue" />
            <div className="ml-1.5 h-1 w-6 rounded-full bg-secondary-light-blue" />
            <div className="ml-1.5 h-1 w-6 rounded-full bg-secondary-light-blue" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
